import { useState, useEffect } from 'react';

function useBrowserDetection() {
  const [browser, setBrowser] = useState('Unknown');

  useEffect(() => {
    const userAgent = navigator.userAgent;

    // Check Edge first because its User Agent string also contains "Chrome"
    if (userAgent.includes("Edg/") || userAgent.includes("Edge/")) {
      setBrowser("Microsoft Edge");
    } else if (userAgent.includes("Chrome")) {
      setBrowser("Chrome");
    } else if (userAgent.includes("Firefox")) {
      setBrowser("Firefox");
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      setBrowser("Safari");
    }
  }, []);

  return browser;
};

export default useBrowserDetection;